<template>
  <div class="itinerary itinerary-promo mb-3" :class="{ active: visible }">
    <div class="itinerarySummary">
      <div class="itinerarySummary__destinations">
        <div class="row gy-5">
          <div class="col-12 col-xl-7 d-flex align-items-center  justify-content-center">
            <div class="itinerarySummary__destination itinerarySummary__destination--start">
              <div>
                <div class="city">
                  Warszawa centralna
                </div>
              </div>
            </div>
            <div class="itinerarySummary__number">
              {{ duration }}
              <hr>
              <small>{{ trainNumber }}<br v-if="change">{{ change }}</small>
            </div>
            <div class="itinerarySummary__destination itinerarySummary__destination--end">
              <div>
                <div class="city">
                  Warszawa centralna
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-5 d-flex align-items-center justify-content-center">
            <div class="itinerarySummary__price order-2 order-xl-1 mx-2">
              <strong>od 49zł</strong>
            </div>
            <div class="itinerarySummary__button-std order-1 order-xl-2 mx-2" v-if="buyButton">
              <a :href="buyButton" class="btn btn-warning">Kup bilet</a>
            </div>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
export default {
  name: 'itinerary-examples',
  props: {
    dateStart: {
      type: String,
      // required: true
    },
    timeStart: {
      type: String,
      // required: true
    },
    dateEnd: {
      type: String,
      // required: true
    },
    timeEnd: {
      type: String,
      // required: true
    },
    trainNumber: {
      type: String,
      // required: true
    },
    duration: {
      type: String,
      // required: true
    },
    change: {
      type: String
    },
    buyButton: {
      type: String
    },
    details: {
      type: String
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    }
  }
}
</script>